var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuella1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 165,
    viewBox: "0 0 143 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3031 4.39371L14.6292 4.80753C1.31653 12.8956 -3.72119 29.7732 2.90827 43.9134C4.26434 46.8102 5.67209 49.62 7.07984 52.165C14.3708 65.3203 63.9253 194.068 87.2411 158.955C110.557 123.843 147.003 60.9317 142.642 52.1526C138.28 43.3734 126.609 27.28 113.494 27.28C108.347 27.28 100.732 29.0822 93.3765 31.2733C80.0246 35.2501 65.6928 29.5394 58.6292 17.4869L57.1925 15.0351C48.6054 0.404489 29.7734 -4.38133 15.3031 4.39371Z",
    fill: "#164453"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuella1);
export default __webpack_public_path__ + "static/media/huella1.407e650c139dad7cdc34263f23cd75c6.svg";
export { ForwardRef as ReactComponent };